import React, { useEffect, useMemo } from "react";
import s from "./MainPhoto.module.scss";
import useWindowDimensions from "../WindowDimensions/WindowDimensions";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { getContactLinks } from "../../redux/InformationSlice";
import { buildContactLinksMap } from "../../utils/contactLinks";

const MainPhoto = () => {
  const dispatch: AppDispatch = useDispatch();
  const contactLinks = useSelector((state: RootState) => state.info.contactLinks);
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const links = useMemo(() => buildContactLinksMap(contactLinks), [contactLinks]);

  useEffect(() => {
    if (!contactLinks?.length) {
      dispatch(getContactLinks());
    }
  }, [dispatch, contactLinks]);

  return (
    <div className={s.content}>
      <div className={s.text}>
        <div className={s.title}>
          <strong>{t("Здоровая миграция - ")} </strong>
          <br />
          {t("Выбери свой маршрут")}
        </div>
        <div className={s.subtitle}>
          {t(
            "Быстрый и понятный путь к информации о здоровье, лечении и поддержке за рубежом",
          )}
        </div>
      </div>
      <div className={s.photo}>
        <img src="/images/Group 3.svg" className={s.photo_img} alt="" />
      </div>
      {width > 1100 && (
        <div className={s.buttons}>
          <Link
            to={links.consultant}
            target="_blank"
            rel="noopener noreferrer"
            className={s.btnWrapper}
          >
            <div className={s.btn}>
              <div className={s.iconWrap}>
                <img src="/images/Vector.svg" alt="" className={s.icon} />
              </div>

              <div>
                <div className={s.btnTitle}>{t("Я консультант")}</div>
                <div className={s.btnSubtitle}>
                  {t("Можете задать свой вопрос")}
                </div>
              </div>
            </div>
          </Link>
          <Link
            to={links.jurist}
            target="_blank"
            rel="noopener noreferrer"
            className={s.btnWrapper}
          >
            <div className={s.btn}>
              <div className={s.iconWrap}>
                <img src="/images/Vector2.svg" alt="" className={s.icon} />
              </div>

              <div className={s.btnText}>
                <div className={s.btnTitle}>{t("Я юрист")}</div>
                <div className={s.btnSubtitle}>
                  {t("Можете задать свой вопрос")}
                </div>
              </div>
            </div>
          </Link>
          <Link
            to={links.ai}
            target="_blank"
            rel="noopener noreferrer"
            className={s.btnWrapper}
          >
            <div className={s.btn}>
              <div className={s.iconWrap}>
                <img src="/images/Vector3.svg" alt="" className={s.icon} />
              </div>

              <div className={s.btnText}>
                <div className={s.btnTitle}>{t("Я ИИ")}</div>
                <div className={s.btnSubtitle}>
                  {t("Можете задать свой вопрос")}
                </div>
              </div>
            </div>
          </Link>
        </div>
      )}
    </div>
  );
};

export default MainPhoto;
